export interface IFeature {
  id: number;
  name: string;
}

export const defaultFeature: IFeature = {
  id: 0,
  name: '',
};
